import type {
  GetLocationPrecisionOverridesResponse,
  SearchLocationPrecisionOverridesResponse,
} from "@thalamos/vision-common";
import {
  locationPrecisionOverrideConfig,
  locationPrecisionOverrideRequests,
} from "@thalamos/vision-common";

import { useApiAxios } from "../axios/api.js";

export const api = locationPrecisionOverrideRequests;

export const apiHooks = () => {
  return {
    locationPrecisionOverride: {
      getAll: function useGetAll() {
        return useApiAxios<GetLocationPrecisionOverridesResponse>(
          locationPrecisionOverrideConfig.getAll(),
        );
      },
      search: function useSearch(query: string, limit: number, offset: number) {
        return useApiAxios<SearchLocationPrecisionOverridesResponse>(
          locationPrecisionOverrideConfig.search(query, limit, offset),
        );
      },
    },
  };
};
